import loadable from '@loadable/component';

export const UserDashboardPreviewEventPageLoadable = loadable(
  () => import('./UserDashboardPreviewEventPage'),
  {
    resolveComponent: (module) => module.UserDashboardPreviewEventPage,
  },
);
